import type { ICentrifugoSubscription } from 'api/notificationCenter';
import { createContext } from 'react';
import { ConnectionStatus } from './types';

export interface ICentrifugoContextData {
  settings: ICentrifugoSubscription | null;
  status: ConnectionStatus;
}

export const CentrifugoContext = createContext<ICentrifugoContextData>({
  settings: null,
  status: ConnectionStatus.Disconnected,
});
